import MonitoringPage from './monitoring-page';

export default MonitoringPage;